const settings = {
  AMPLIFY_CALLBACKS: {
    REDIRECT_SIGN_IN: process.env.REACT_APP_AWS_AMPLIFY_CALLBACKS_URL_SIGNIN,
    REDIRECT_SIGN_OUT: process.env.REACT_APP_AWS_AMPLIFY_CALLBACKS_URL_SIGNOUT,
  },
  AWS_COGNITO: {
    AUTH_IDENTITY_POOL_ID: process.env.REACT_APP_AWS_COGNITO_AUTH_IDENTITY_POOL_ID,
    AUTH_USER_POOL_ID: process.env.REACT_APP_AWS_COGNITO_AUTH_USER_POOL_ID,
    AUTH_USER_POOL_WEB_CLIENT_ID: process.env.REACT_APP_AWS_COGNITO_AUTH_USER_POOL_WEB_CLIENT_ID,
    AUTH_REGION: process.env.REACT_APP_AWS_COGNITO_AUTH_REGION,
  },
  AWS_AMPLIFY_DOMAIN: process.env.REACT_APP_AWS_AMPLIFY_DOMAIN,
  BE_ENDPOINT: process.env.REACT_APP_BE_ENDPOINT,
  GOOGLE_TAG_MANAGER_PROD: process.env.REACT_APP_GOOGLE_TAG_MANAGER_PROD,
  AMPLITUDE_KEY: process.env.REACT_APP_AMPLITUDE,
  SENTRY: process.env.REACT_APP_SENTRY_DNS,
  RESUME_BE_ENDPOINT: process.env.REACT_APP_RESUME_BE_ENDPOINT,
};

export default settings;
